import styled from '@emotion/styled'
import ManagePageLayout from '@/components/manage/Layout'
import { Flex } from '@collable/ui'
import ManageChannelHeader from '@/components/manage/channel/Header'
import ManageChannelInfo from '@/components/manage/channel/ChannelInfo'
import { useManagePageQueryParams } from '@/hooks/queryParams/useManagePageQueryParams'
import { useGetChannelSettings } from '@/api/channel'

const ChannelPage = () => {
  const { selectedChannel } = useManagePageQueryParams()
  const { isFetched } = useGetChannelSettings(selectedChannel?.channelId ?? 0)

  return (
    <ManagePageLayout pageType="channel">
      <Container direction="column" gap={48}>
        <ManageChannelHeader />
        {isFetched && <ManageChannelInfo channelId={selectedChannel?.channelId ?? 0} />}
      </Container>
    </ManagePageLayout>
  )
}

export default ChannelPage

const Container = styled(Flex)`
  padding: 48px;
  flex: 1;
  height: 100%;
  overflow-y: scroll;
`
